export default (params) => ({
  trigger: {
    name: 'postal_code_checker.read_more',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'order_block',
          'postal_code_checker_overlay',
        ],
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        subject_type: 'label',
        subject_id: 'postal_code_checker_explanation',
      },
    },
    nonInt: false,
  },
});
